// src/components/StatusSelector.web.js - Web version matching your original StatusSelector
import React from 'react';
import { View, StyleSheet, Modal, TouchableOpacity } from 'react-native';
import { Card, Title, Button, Divider, Text } from 'react-native-paper';
import WebIcon from './WebIcon';

const StatusSelectorWeb = ({ 
  visible, 
  onDismiss, 
  statuses, 
  currentStatus, 
  onStatusSelect, 
  requiresSignature // Add this prop for the order's requiresSignature field
}) => {
  const getStatusIcon = (statusName, isCurrent) => {
    if (isCurrent) {
      return 'check';
    }
    return 'circle-outline';
  };

  const getStatusIconColor = (statusName, isCurrent) => {
    if (isCurrent) {
      return '#4CAF50';
    }
    return '#999';
  };

  return (
    <Modal
      visible={visible}
      transparent={true}
      animationType="fade"
      onRequestClose={onDismiss}
    >
      {/* Full screen backdrop */}
      <View style={styles.modalOverlay}>
        {/* Modal Content */}
        <View style={styles.modalContent}>
          <Card style={styles.card}>
            <Card.Content>
              <Title style={styles.title}>בחר סטטוס חדש</Title>
              <Divider style={styles.divider} />
              
              {statuses
                .filter((status) => {
                  // Always filter out status with id "1"  
                  if (status.id === "1") return false;
                  
                  // If requiresSignature is "Yes", also filter out status with id "4"
                  //if (requiresSignature === "Yes" && status.id === "4") return false;
                  
                  return true;
                })
                .map((status) => {
                  const isCurrent = currentStatus === status.statusName;
                  
                  return (
                    <TouchableOpacity
                      key={status.id}
                      onPress={() => onStatusSelect(status.id)}
                      style={[
                        styles.statusItem,
                        isCurrent && styles.currentStatus
                      ]}
                    >
                      <View style={styles.statusItemContent}>
                        <View style={styles.statusIcon}>
                          <WebIcon 
                            name={getStatusIcon(status.statusName, isCurrent)}
                            size={24}
                            color={getStatusIconColor(status.statusName, isCurrent)}
                          />
                        </View>
                        <Text style={[
                          styles.statusText,
                          isCurrent && styles.currentStatusText
                        ]}>
                          {status.statusName}
                        </Text>
                      </View>
                    </TouchableOpacity>
                  );
                })}

              <Button 
                mode="outlined" 
                onPress={onDismiss}
                style={styles.cancelButton}
              >
                ביטול
              </Button>
            </Card.Content>
          </Card>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.8)', // Solid dark overlay
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  modalContent: {
    width: '100%',
    maxWidth: 400,
    maxHeight: '80%',
  },
  card: {
    borderRadius: 12,
    elevation: 8,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    backgroundColor: '#fff', // Ensure solid background
  },
  title: {
    textAlign: 'center',
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
  },
  divider: {
    marginVertical: 16,
  },
  statusItem: {
    borderRadius: 8,
    marginBottom: 4,
    paddingVertical: 12,
    paddingHorizontal: 16,
  },
  currentStatus: {
    backgroundColor: '#e8f5e8',
  },
  statusItemContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  statusIcon: {
    marginRight: 16,
    width: 24,
    height: 24,
    justifyContent: 'center',
    alignItems: 'center',
  },
  statusText: {
    fontSize: 16,
    flex: 1,
  },
  currentStatusText: {
    fontWeight: 'bold',
    color: '#4CAF50',
  },
  cancelButton: {
    marginTop: 16,
    borderRadius: 8,
  },
});

export default StatusSelectorWeb;